jQuery(function($) {
  $(window).load(function () {
    $('<span class="dropdown-sort-label">Sort:</span>').delay(1500).insertBefore('.wcf-filter-form.layout-horizontal .wcf-horizontal-trigger.wcf-horizontal-sort [data-baseweb="select"]');

    // remove add to cart listener blocksy is using to force ajax
    const cart_form = document.querySelector( 'form.cart' )
    if ( cart_form ) {
      const new_cart_form = cart_form.cloneNode(true)
      cart_form.parentNode.replaceChild( new_cart_form, cart_form )
    }

  });
});
